module.exports = __webpack_public_path__ + "static/assets/7d3e0f10e7116807851e7e5ecf3a2a14.svg";